import { z } from "zod";

export const CriarGruposSchema = z.object({
    nome: z.string()
        .nonempty("O nome do grupo é obrigatório.")
        .min(3, "O nome do grupo deve ter no mínimo 3 caracteres")
        .max(100, "O nome do grupo deve ter no máximo 100 caracteres"),

    status: z.enum(["S", "N"], {
        errorMap: () => ({ message: "O status deve ser 'S' ou 'N'" })
    })
});